// extracted by mini-css-extract-plugin
export default {"screenTableOuter":"screening_screenTableOuter__h3NT8","ipLabel":"screening_ipLabel__ce762","loader":"screening_loader__QwUGA"};